export default class NavItemModel {
    constructor(title, icon, link) {
        this.title = title;
        this.icon = icon;
        this.link = link;
    }
}